import React, { useState, useRef } from 'react';

type DragAndDropType = {
  handleChangeCsvOptions: (data: string) => void;
}

export function DragAndDrop({ handleChangeCsvOptions }: DragAndDropType) {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [wasSelectedACsvFile, setWasSelectedACsvFile] = useState<boolean>(false);
  const [csvFileName, setCsvFileName] = useState<string>('');

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    handleFile(file);
  };

  const handleFileInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files && e.target.files[0];
    if (file) {
      setCsvFileName(file.name);
      handleFile(file);
    }
  };

  const handleFile = (file: File) => {
    if (file.type === 'text/csv') {
      const reader = new FileReader();
      reader.onload = (event) => {
        setWasSelectedACsvFile(true);
        const result = event.target?.result as string;
        handleChangeCsvOptions(result);
      };
      reader.readAsText(file);
    } else {
      alert('Por favor, selecione um arquivo CSV.');
      setWasSelectedACsvFile(false);
    }
    setWasSelectedACsvFile(false);
  };

  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  return (
    <div
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onClick={() => fileInputRef.current?.click()}
      style={{
        width: '100%',
        height: 60,
        border: '2px dashed #ccc',
        borderRadius: 5,
        textAlign: 'center',
        cursor: 'pointer',
        marginTop: '10px',
        marginBottom: '10px'
      }}
    >

      {wasSelectedACsvFile ? (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <span style={{ fontWeight: 'bold' }}>Arquivo selecionado! 🚀</span>
          <span>{csvFileName}</span>
        </div>
      )
        : (
          <div style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <span>Arraste e solte um arquivo CSV ou clique para selecionar manualmente.</span>
          </div>
        )
      }

      <input
        type="file"
        accept=".csv"
        ref={fileInputRef}
        style={{ display: 'none' }}
        onChange={handleFileInput}
      />
    </div>
  );
}
